import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'app-welcome-message',
    imports: [],
    templateUrl: './welcome-message.component.html',
    styleUrls: ['./welcome-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeMessageComponent {
  @Input() message: string;
}
